namespace Solovis.Reports.Layouts {

    export class VerticalLayoutPart extends LayoutPart {

        constructor(options) {
            super(options);
        }

        public createPart(parentElement) {
            var self = this;

            this.layoutDiv = $("<div>").css("display", "none").appendTo(parentElement);

            if (this.partDefinition.style) {
                this.reportControl._applyStyleToPartContainer(this.partDefinition.style, this.layoutDiv);
            }

            if (this.partDefinition.children) {
                $(this.partDefinition.children).each(function (i, child) {
                    var childPart = self.reportControl._createPartContainer({ parentElement: self.layoutDiv, partDefinition: child });
                    self.childPartList.push(childPart);
                });
            }
        };
    }

}